import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { AppRoutes } from '../AppRoutes';

const FormsPage = lazy(() =>
  import('@/pages/forms').then((module) => ({
    default: module.FormsPage,
  }))
);
const CreateFormPage = lazy(() =>
  import('@/pages/forms').then((module) => ({
    default: module.CreateFormPage,
  }))
);
const FormDetailViewPage = lazy(() =>
  import('@/pages/forms').then((module) => ({
    default: module.FormDetailViewPage,
  }))
);
const FormBrowseView = lazy(() =>
  import('@/pages/forms').then((module) => ({
    default: module.FormBrowseView,
  }))
);
const DynamicFormDetailViewPage = lazy(() =>
  import('@/pages/forms').then((module) => ({
    default: module.DynamicFormDetailViewPage,
  }))
);
const DynamicFormCreatePage = lazy(() =>
  import('@/pages/forms').then((module) => ({
    default: module.DynamicFormCreatePage,
  }))
);

export const formsRouter: RouteObject[] = [
  {
    path: AppRoutes.FORMS,
    element: <FormsPage />,
  },
  {
    path: AppRoutes.FORMS_CREATE,
    element: <CreateFormPage />,
  },
  {
    path: AppRoutes.FORMS_DETAILS,
    element: <FormDetailViewPage />,
  },
  {
    path: AppRoutes.FORMS_BROWSE,
    element: <FormBrowseView />,
  },
  {
    path: AppRoutes.FORMS_DYNAMIC_DETAILS,
    element: <DynamicFormDetailViewPage />,
  },
  {
    path: AppRoutes.FORMS_DYNAMIC_CREATE,
    element: <DynamicFormCreatePage />,
  },
];
